function ExpiredResetLink(){

    return(
        <>
            <h1 style={{borderBottom : "none"}}>Reset password link has expired.</h1>
        </>
    )
}

export default ExpiredResetLink;